import { useState } from 'react';
import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
var useSelectedLanguage = function () {
    var _a = useState(getLanguageFromStorage()), selectedLang = _a[0], setSelectedLang = _a[1];
    var handleLanguageChange = function () {
        var lang = selectedLang === 'en' ? 'es' : 'en';
        localStorage.setItem('language', lang);
        setSelectedLang(lang);
    };
    return {
        onLangChange: handleLanguageChange,
        selectedLang: selectedLang
    };
};
export default useSelectedLanguage;
//# sourceMappingURL=use-selected-language.js.map